import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function screenReducer(state = initialState.currentScreen, action) {
  switch (action.type) {
    case types.LOAD_SCREEN_MESSAGES_INBOX: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_GROUPS_CHAT: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_GROUP_CHAT_DETAIL: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_MEMBER_SEARCH: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_INBOX_DETAIL: {
      state = action.screenName;
      return action.screenName;
    }
    case types.LOAD_SCREEN_FACE_BOOK_ACTIVE: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_FOGOT_PASSWORD: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_RESET_PASSWORD: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_SPLASH: {
      state = action.screenName;
      return action.screenName;
    }
    case types.LOAD_SCREEN_USER_LOGIN: {
      state = action.screenName;
      return action.screenName;
    }
    case types.LTM_LOAD_SCREEN: {
      state = action.screenName;
      return action.screenName;
    }

    case types.TU1_LOAD_SCREEN: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_SCREEN_LOCATION_SELECTOR: {
      state = action.screenName;
      return action.screenName;
    }

    case types.LOAD_INTRODUCE_YOURSELF_SCREEN: {
      state = action.screenName;
      return action.screenName;
    }

    default:
      return state;
  }
}
